<div style="margin-left: 4%; margin-right: 4%">
  @if (showErrorsDisclaimer) {
    <div style="margin-top: 2.625rem" id="errorDisclaimerID" class="errorDisclaimer">
      <img src="assets/error.svg" />
      <span> There are errors on the form. Please fix the errors in order to continue. </span>
    </div>
  }
  @if (showMaterialHardwareOnlyErrorDisclaimer) {
    <div
      style="margin-top: 2.625rem"
      id="materialHardwareErrorDisclaimerID"
      class="errorDisclaimer"
    >
      <img src="assets/error.svg" />
      <span>
        A Hardware Only form must have at least one row in the materials section that is a CAP row.
        Please add a CAP material record to continue.
      </span>
    </div>
  }
  @if (showMaterialHardwareSoftwareErrorDisclaimer) {
    <div
      style="margin-top: 2.625rem"
      id="materialHardwareErrorDisclaimerID"
      class="errorDisclaimer"
    >
      <img src="assets/error.svg" />
      <span>
        A Hardware and Software form needs at least one row in the Materials section that is a
        Hardware CAP row, and at least one row additional row in either the Materials or Labor
        section that is a Software CAP row.
      </span>
    </div>
  }
  @if (showMaterialSoftwareOnlyErrorDisclaimer) {
    <div
      style="margin-top: 2.625rem"
      id="materialSoftwareErrorDisclaimerID"
      class="errorDisclaimer"
    >
      <img src="assets/error.svg" />
      <span>
        A Software Only form must have at least one CAP row in either the Materials or Labor
        section. Please add a CAP material or CAP labor record to continue.
      </span>
    </div>
  }
  @if (showMaterialOmOnlyErrorDisclaimer) {
    <div style="margin-top: 2.625rem" id="materialOmOnlyErrorDisclaimerID" class="errorDisclaimer">
      <img src="assets/error.svg" />
      <span>
        An O&M form must have at least one row in either the Materials or Labor section. Please add
        a material or labor record to continue.
      </span>
    </div>
  }
  @if (displayRevisionNumber > 0) {
    <div>
      <div style="margin-top: 2.625rem; display: inline-block">
        <span class="itProjectHeader" style="font-size: 1.313rem"
          >Form #{{ formNumber }}, Rev {{ displayRevisionNumber }}</span
        >
      </div>
      <div style="display: inline-block; float: right; margin-top: 2.625rem; margin-right: 1.4rem">
        <button [matMenuTriggerFor]="menu" class="action-button" matTooltip="Actions">
          <mat-icon style="color: rgb(0, 120, 158)">more_vert</mat-icon>
        </button>
        <mat-menu #menu="matMenu">
          <button mat-menu-item>
            <span>Print Form</span>
          </button>
          @if (showDelete()) {
            <button mat-menu-item (click)="openDeleteConfirmationDialog()">
              <span>Delete Form</span>
            </button>
          }
        </mat-menu>
        <div class="exitButton" (click)="saveDraft()">
          <span class="exitText">SAVE DRAFT</span>
        </div>
      </div>
    </div>
  }
  <div style="margin-top: 2.625rem; display: inline-block">
    <span class="itProjectHeader">Accounting Request Form</span>
  </div>
  @if (draftSaved) {
    <div style="display: inline-block; margin-top: 2.625rem">
      <div
        style="
          display: inline-block;
          margin-left: 1rem;
          background: #d7d9da 0% 0% no-repeat padding-box;
          border-radius: 8px;
          opacity: 1;
          width: 3.438rem;
          text-align: center;
        "
      >
        <span style="color: #4c4c4c; font-size: 0.875rem">Draft</span>
      </div>
      <div style="display: inline-block; margin-left: 1rem">
        <span style="color: #4c4c4c; font-size: 0.75rem; font-style: italic"
          >Saved {{ draftSavedTime }} on {{ draftSavedDay }}</span
        >
      </div>
    </div>
  }
  @if (displayRevisionNumber === 0) {
    <div style="display: inline-block; float: right; margin-top: 2.625rem; margin-right: 1.4rem">
      <button [matMenuTriggerFor]="menu" class="action-button" matTooltip="Actions">
        <mat-icon style="color: rgb(0, 120, 158)">more_vert</mat-icon>
      </button>
      <mat-menu #menu="matMenu">
        <button mat-menu-item>
          <span>Print Form</span>
        </button>
        @if (showDelete()) {
          <button mat-menu-item (click)="openDeleteConfirmationDialog()">
            <span>Delete Form</span>
          </button>
        }
      </mat-menu>
      <div class="exitButton" (click)="saveDraft()">
        <span class="exitText">SAVE DRAFT</span>
      </div>
    </div>
  }
  <form #projectEstimateForm="ngForm" (keydown.enter)="$event.preventDefault()">
    <div style="display: inline-block; margin-top: 1.5rem">
      <div
        style="width: 23.438rem; height: 6.25rem; background-color: #f3fafd"
        [class.backgroundWhite]="isRevisionIndicator"
      >
        <div style="display: inline-block; margin-top: 1.125rem; margin-left: 1.5rem">
          @if (!isRevisionIndicator) {
            <mat-form-field class="itFields" style="width: 19.4rem">
              <mat-select
                [(ngModel)]="department"
                placeholder="Who will this work benefit?"
                (selectionChange)="deleteDefaultOption(); assignAllocationDefaults($event.value)"
                required
                [ngModelOptions]="{ standalone: true }"
                [compareWith]="compareDepartment"
              >
                @for (option of defaultsByDepartment; track option) {
                  <mat-option style="color: #696969" [value]="option"
                    ><span>{{ option.department }}</span></mat-option
                  >
                }
              </mat-select>
            </mat-form-field>
          }
          @if (department && isRevisionIndicator) {
            <mat-form-field class="itFields" style="width: 19.4rem">
              <input
                readonly="true"
                type="text"
                placeholder="Department"
                matInput
                [(ngModel)]="department.department"
                [ngModelOptions]="{ standalone: true }"
              />
            </mat-form-field>
          }
        </div>
      </div>
    </div>
    <div style="display: inline-block; margin-left: 1.5rem; margin-top: 1.5rem">
      <div style="width: 38.438rem; height: 6.25rem; background-color: #f3fafd">
        <div style="display: inline-block; margin-top: 1.125rem; margin-left: 1.5rem">
          @if (!(buildingInfo && buildingInfo.BuildingName)) {
            <mat-form-field class="itFields" style="width: 34.563rem">
              <input
                type="text"
                placeholder="Building Info (Building Name)"
                matAutocompletePosition="below"
                matInput
                [matAutocomplete]="auto1"
                [formControl]="buildingInfoControl"
                [(ngModel)]="buildingInfo"
                required
                name="buildingInfoField"
              />
            </mat-form-field>
          }
          @if (buildingInfo && buildingInfo.BuildingName) {
            <mat-form-field class="itFields" style="width: 34.563rem">
              <input
                type="text"
                placeholder="Building Info (Building Name)"
                matAutocompletePosition="below"
                matInput
                [matAutocomplete]="auto1"
                [formControl]="buildingInfoControl"
                [(ngModel)]="buildingInfo"
                readonly="true"
              />
            </mat-form-field>
          }
          <mat-autocomplete
            #auto1="matAutocomplete"
            [displayWith]="displayFnBuildingInfo"
            (optionSelected)="assignBuilding($event.option.value)"
          >
            @for (option of filteredBuildingInfoOptions | async; track option) {
              <mat-option style="color: #696969" [value]="option"
                ><span>{{ option.BuildingName }}</span></mat-option
              >
            }
          </mat-autocomplete>
          @if (buildingInfo && buildingInfo.BuildingName) {
            <div style="display: inline-block; padding-top: 0.8rem; z-index: 0; position: absolute">
              <img
                (click)="deleteBuildingInfo()"
                style="margin-left: -1.5rem; cursor: pointer"
                src="assets/close-window.svg"
              />
            </div>
          }
        </div>
      </div>
    </div>
    @if (!(hardwareOrSoftware === 'Hardware Only' || hardwareOrSoftware === 'O&M Only')) {
      <div style="margin-top: 1.5rem; margin-bottom: 0.5rem">
        <span class="projectScopeHeader">Release Details</span>
      </div>
    }
    @if (!(hardwareOrSoftware === 'Hardware Only' || hardwareOrSoftware === 'O&M Only')) {
      <div style="background-color: #f3fafd; padding-top: 1.5rem; width: 78rem">
        <div style="width: 78rem; margin-bottom: 1.5rem; text-align: center">
          <span class="projectScopeHeader">Capability and Release Details</span>
        </div>
        <div style="height: 0.1rem; background-color: #f5f5f5"></div>
      </div>
    }
    <div>
      @if (!(hardwareOrSoftware === 'Hardware Only' || hardwareOrSoftware === 'O&M Only')) {
        <div>
          @for (releaseDetail of releaseDetails; track releaseDetail; let i = $index) {
            <div>
              @for (
                capabilityDetail of releaseDetail.capabilityDetails;
                track capabilityDetail;
                let j = $index;
                let jindex = $index
              ) {
                <div>
                  <div
                    style="width: 78rem; height: 6.25rem"
                    [class.backgroundColorBlue]="!isOdd(i)"
                    [class.backgroundColorGray]="isOdd(i)"
                  >
                    <div style="display: inline-block; margin-top: 1.125rem; margin-left: 1.5rem">
                      <mat-form-field
                        [class.backgroundBlue]="jindex !== 0"
                        class="itFields"
                        style="width: 6rem"
                      >
                        <input
                          [(ngModel)]="capabilityDetail.releaseNumber"
                          placeholder="Release #"
                          matInput
                          [readonly]="jindex !== 0"
                          (change)="releaseNumberChange(i, jindex)"
                          required
                          [name]="'releaseDetail.capabilityDetail.releaseNumberField' + i + jindex"
                        />
                      </mat-form-field>
                    </div>
                    <div style="display: inline-block; margin-top: 1.125rem; margin-left: 0.5rem">
                      <mat-form-field
                        [class.backgroundBlue]="jindex !== 0"
                        style="
                          background: white;
                          padding-left: 0.4rem;
                          padding-right: 0.4rem;
                          margin-top: 1.125rem;
                          width: 7.1rem;
                          height: 4rem;
                        "
                      >
                        <mat-label>Release Date</mat-label>
                        <input
                          matInput
                          [matDatepicker]="dp"
                          [(ngModel)]="capabilityDetail.releaseDate"
                          style="color: #696969"
                          [min]="estimatedStartDate"
                          [max]="estimatedInServiceDate"
                          [readonly]="jindex !== 0"
                          (dateChange)="releaseDateChange(i, jindex)"
                          required
                          [name]="'releaseDetail.capabilityDetail.releaseDateField' + i + jindex"
                        />
                        <mat-datepicker-toggle matSuffix [for]="dp"></mat-datepicker-toggle>
                        <mat-datepicker #dp></mat-datepicker>
                      </mat-form-field>
                    </div>
                    <div style="display: inline-block; margin-top: 1.125rem; margin-left: 0.5rem">
                      <mat-form-field
                        class="itFields"
                        style="width: 19.138rem; cursor: pointer"
                        (click)="openCapabilityDialog(i, jindex)"
                      >
                        <input
                          readonly="true"
                          style="pointer-events: none"
                          [(ngModel)]="capabilityDetail.capabilities"
                          placeholder="Capability"
                          matInput
                          required
                          [name]="'releaseDetail.capabilityDetail.capabilityField' + i + jindex"
                        />
                      </mat-form-field>
                    </div>
                    <div style="display: inline-block; margin-top: 1.125rem; margin-left: 0.5rem">
                      <mat-form-field
                        class="itFields"
                        style="width: 19.138rem; cursor: pointer"
                        (click)="openCapabilityDialog(i, jindex)"
                      >
                        <input
                          readonly="true"
                          style="pointer-events: none"
                          [(ngModel)]="capabilityDetail.description"
                          placeholder="Detailed Description of Capability"
                          matInput
                          required
                          [name]="'releaseDetail.capabilityDetail.descriptionField' + i + jindex"
                        />
                      </mat-form-field>
                    </div>
                    <div style="display: inline-block; margin-top: 1.125rem; margin-left: 0.5rem">
                      <mat-form-field class="itFields" style="width: 6rem" [floatLabel]="'always'">
                        <input
                          appCurrencyMask
                          appNumbersOnly
                          [allowDecimals]="true"
                          onkeypress="return event.charCode != 45;"
                          [(ngModel)]="capabilityDetail.capitalCost"
                          placeholder="Capital Cost"
                          matInput
                          [name]="'releaseDetail.capabilityDetail.capitalCostField' + i + jindex"
                        />
                        <span matPrefix>$</span>
                      </mat-form-field>
                    </div>
                    <div style="display: inline-block; margin-top: 1.125rem; margin-left: 0.5rem">
                      <mat-form-field class="itFields" style="width: 6rem" [floatLabel]="'always'">
                        <input
                          appCurrencyMask
                          appNumbersOnly
                          [allowDecimals]="true"
                          onkeypress="return event.charCode != 45;"
                          [(ngModel)]="capabilityDetail.omCost"
                          placeholder="O&M Cost"
                          matInput
                          [name]="'releaseDetail.capabilityDetail.OMCostField' + i + jindex"
                        />
                        <span matPrefix>$</span>
                      </mat-form-field>
                    </div>
                    <div style="display: inline-block; margin-top: 1.125rem; margin-right: 0.5rem">
                      <img
                        style="cursor: pointer; width: 1rem; height: 1rem; padding-left: 2.5rem"
                        src="assets/trash-bin-base.svg"
                        (click)="deleteRelease(i, jindex)"
                      />
                    </div>
                  </div>
                </div>
              }
              <div>
                <div
                  style="width: 78rem"
                  [class.backgroundColorBlue]="!isOdd(i)"
                  [class.backgroundColorGray]="isOdd(i)"
                >
                  <div
                    style="
                      padding-left: 2rem;
                      padding-top: 1.563rem;
                      padding-bottom: 1.313rem;
                      cursor: pointer;
                      width: 15rem;
                    "
                    (click)="addCapability(i)"
                  >
                    <span style="font-weight: bold; font-size: 1.4rem">&#43;</span>
                    <span
                      style="
                        padding-left: 0.2rem;
                        text-decoration: underline;
                        text-underline-offset: 0.2rem;
                      "
                      >Add a Capability to this Release</span
                    >
                  </div>
                </div>
              </div>
            </div>
          }
          <div style="height: 0.1rem; background-color: #f5f5f5; width: 78rem"></div>
          <div style="width: 78rem; background-color: #f3fafd">
            <div
              style="
                padding-left: 1rem;
                padding-top: 1.188rem;
                padding-bottom: 1.313rem;
                cursor: pointer;
                width: 15rem;
              "
              (click)="addRelease()"
            >
              <span style="font-weight: bold; font-size: 1.4rem">&#43;</span>
              <span
                style="
                  padding-left: 0.2rem;
                  text-decoration: underline;
                  text-underline-offset: 0.2rem;
                "
                >Add Another Release</span
              >
            </div>
          </div>
        </div>
      }
      <div style="display: inline-block; margin-top: 1.5rem">
        <div
          style="width: 23.438rem; height: 6.25rem; background-color: #f3fafd"
          [class.backgroundWhite]="isRevisionIndicator"
        >
          <div style="display: inline-block; margin-top: 1.125rem; margin-left: 1.5rem">
            @if (!isRevisionIndicator) {
              <mat-form-field class="itFields" style="width: 19.4rem">
                <mat-select
                  [(ngModel)]="distributeCost"
                  placeholder="How do you want to distribute cost across business?"
                  (selectionChange)="distributeCostChange($event.value)"
                  required
                  [ngModelOptions]="{ standalone: true }"
                >
                  @for (option of distributeOptions; track option) {
                    <mat-option style="color: #696969" [value]="option"
                      ><span>{{ option }}</span></mat-option
                    >
                  }
                </mat-select>
              </mat-form-field>
            }
            @if (isRevisionIndicator) {
              <mat-form-field class="itFields" style="width: 19.4rem">
                <input
                  readonly="true"
                  type="text"
                  placeholder="How do you want to distribute cost across business?"
                  matInput
                  [(ngModel)]="distributeCost"
                  [ngModelOptions]="{ standalone: true }"
                />
              </mat-form-field>
            }
          </div>
        </div>
      </div>
      @if (!(distributeCost !== 'Default' || !(department && department.department))) {
        <div style="display: inline-block; margin-left: 1.5rem; margin-top: 1.5rem">
          <div
            style="width: 23.438rem; height: 6.25rem; background-color: #f3fafd"
            [class.backgroundWhite]="isRevisionIndicator"
          >
            <div style="display: inline-block; margin-top: 1.125rem; margin-left: 1.5rem">
              @if (!isRevisionIndicator) {
                <mat-form-field class="itFields" style="width: 19.4rem">
                  <mat-select
                    [(ngModel)]="defaultOption"
                    placeholder="Please select one of the default options:"
                    (selectionChange)="
                      setDefaultAllocation($event.value); setAllocationsAsTouched()
                    "
                    required
                    [ngModelOptions]="{ standalone: true }"
                  >
                    @for (option of allocationDefaults; track option) {
                      <mat-option style="color: #696969" [value]="option"
                        ><span>{{ option }}</span></mat-option
                      >
                    }
                  </mat-select>
                </mat-form-field>
              }
              @if (isRevisionIndicator) {
                <mat-form-field class="itFields" style="width: 19.4rem">
                  <input
                    readonly="true"
                    type="text"
                    placeholder="Please select one of the default options:"
                    matInput
                    [(ngModel)]="defaultOption"
                    [ngModelOptions]="{ standalone: true }"
                  />
                </mat-form-field>
              }
            </div>
          </div>
        </div>
      }
      <div style="margin-top: 1.5rem; margin-bottom: 0.5rem">
        <span class="projectScopeHeader">Allocations</span>
      </div>
      @for (allocation of allocations; track allocation; let i = $index) {
        <div>
          <div
            style="height: 6.25rem; background-color: #f3fafd"
            [ngStyle]="{
              width: isAllocationFunctionVisible(allocations) ? '90rem' : '78rem',
            }"
          >
            <div style="display: inline-block; margin-top: 1.125rem; margin-left: 1.5rem">
              @if (
                !isRevisionIndicator &&
                !(allocation.operatingUnit && allocation.operatingUnit.OPERATING_UNIT)
              ) {
                <mat-form-field class="itFields" style="width: 21.563rem">
                  <input
                    type="text"
                    placeholder="Operating Unit"
                    matAutocompletePosition="below"
                    matInput
                    [matAutocomplete]="auto2"
                    [formControl]="operatingUnitControl[i]"
                    [(ngModel)]="allocation.operatingUnit"
                    required
                  />
                </mat-form-field>
              }
              @if (
                isRevisionIndicator ||
                (allocation.operatingUnit && allocation.operatingUnit.OPERATING_UNIT)
              ) {
                <mat-form-field
                  class="itFields"
                  style="width: 21.563rem"
                  [class.backgroundColorBlue]="isRevisionIndicator"
                >
                  <input
                    type="text"
                    placeholder="Operating Unit"
                    matAutocompletePosition="below"
                    matInput
                    [matAutocomplete]="auto2"
                    [formControl]="operatingUnitControl[i]"
                    [(ngModel)]="allocation.operatingUnit"
                    readonly="true"
                  />
                </mat-form-field>
              }
              <mat-autocomplete
                #auto2="matAutocomplete"
                [displayWith]="displayFnOperatingUnit"
                (optionSelected)="
                  setBusinessUnit(allocation, $event.option.value, i);
                  getFundingProjectIDChoices(allocation, $event.option.value, i);
                  getUOPDescriptionChoices();
                  setAllocationsAsTouched();
                  updateMatchingBusinessUnits(i)
                "
              >
                @for (option of filteredOperatingUnitOptions[i] | async; track option) {
                  <mat-option style="color: #696969" [value]="option"
                    ><span>{{ option.OPERATING_UNIT }} - {{ option.DESCR }}</span></mat-option
                  >
                }
              </mat-autocomplete>
              @if (
                !isRevisionIndicator &&
                allocation.operatingUnit &&
                allocation.operatingUnit.OPERATING_UNIT
              ) {
                <div
                  style="display: inline-block; padding-top: 0.8rem; z-index: 0; position: absolute"
                >
                  <img
                    (click)="deleteOperatingUnit(i)"
                    style="margin-left: -1.5rem; cursor: pointer"
                    src="assets/close-window.svg"
                  />
                </div>
              }
            </div>
            <div style="display: inline-block; margin-top: 1.125rem; margin-left: 0.683rem">
              <mat-form-field class="itFields" style="width: 21.563rem; background-color: #f3fafd">
                <input
                  [(ngModel)]="allocation.businessUnit"
                  placeholder="Business Unit"
                  matInput
                  readonly="true"
                  [ngModelOptions]="{ standalone: true }"
                />
              </mat-form-field>
            </div>
            <div style="display: inline-block; margin-top: 1.125rem; margin-left: 0.683rem">
              @if (fundingProjectIDDisabled(allocation, i)) {
                <mat-form-field
                  [class.removeElement]="allocation.hasFundingError"
                  class="itFields"
                  style="width: 9.563rem; background-color: #f3fafd"
                >
                  <input
                    type="text"
                    placeholder="Funding Project ID"
                    matAutocompletePosition="below"
                    matInput
                    [matAutocomplete]="auto6"
                    [formControl]="fundingProjectControl[i]"
                    [(ngModel)]="allocation.fundingProjectID"
                    readonly="true"
                    required
                    [name]="'allocation.fundingProjectIDField' + i"
                  />
                </mat-form-field>
              }
              @if (allocation.fundingProjectID && allocation.fundingProjectID.work_order_number) {
                <mat-form-field
                  [class.removeElement]="
                    fundingProjectIDDisabled(allocation, i) || allocation.hasFundingError
                  "
                  class="itFields"
                  style="width: 9.563rem"
                >
                  <input
                    type="text"
                    placeholder="Funding Project ID"
                    matAutocompletePosition="below"
                    matInput
                    [matAutocomplete]="auto6"
                    [formControl]="fundingProjectControl[i]"
                    [(ngModel)]="allocation.fundingProjectID"
                    readonly="true"
                    required
                    [name]="'allocation.fundingProjectIDField' + i"
                  />
                </mat-form-field>
              }
              @if (
                !(allocation.fundingProjectID && allocation.fundingProjectID.work_order_number)
              ) {
                <mat-form-field
                  [class.removeElement]="
                    fundingProjectIDDisabled(allocation, i) || allocation.hasFundingError
                  "
                  class="itFields"
                  style="width: 9.563rem"
                >
                  <input
                    type="text"
                    placeholder="Funding Project ID"
                    matAutocompletePosition="below"
                    matInput
                    [matAutocomplete]="auto6"
                    [formControl]="fundingProjectControl[i]"
                    [(ngModel)]="allocation.fundingProjectID"
                    required
                    [name]="'allocation.fundingProjectIDField' + i"
                  />
                </mat-form-field>
              }
              <mat-autocomplete
                [class.removeElement]="fundingProjectIDDisabled(allocation, i)"
                #auto6="matAutocomplete"
                [displayWith]="displayFnFundingProject"
                (optionSelected)="updateMatchingBusinessUnits(i)"
              >
                @for (option of filteredFundingProjectOptions[i] | async; track option) {
                  <mat-option style="color: #696969" [value]="option"
                    ><span>{{ option.work_order_number }}</span></mat-option
                  >
                }
              </mat-autocomplete>
              @if (allocation.fundingProjectID && allocation.fundingProjectID.work_order_number) {
                <div
                  [class.removeElement]="
                    fundingProjectIDDisabled(allocation, i) || allocation.hasFundingError
                  "
                  style="display: inline-block; padding-top: 0.8rem; z-index: 0; position: absolute"
                >
                  <img
                    (click)="deleteFundingProjectID(i)"
                    style="margin-left: -1.5rem; cursor: pointer"
                    src="assets/close-window.svg"
                  />
                </div>
              }
              @if (allocation.hasFundingError) {
                <div style="padding-left: 0.5rem; padding-right: 0.5rem; width: 9.563rem">
                  <span style="color: #9e1b32; font-size: 0.875rem"
                    >Projects can not be set up for this business unit</span
                  >
                </div>
              }
            </div>
            <div
              [class.hiddenElement]="stateDisabled(allocation)"
              [class.removeElement]="isRepeatedOperatingUnit(i) && !stateDisabled(allocation)"
              style="display: inline-block; margin-top: 1.125rem; margin-left: 0.683rem"
            >
              <mat-form-field class="itFields" style="width: 6.563rem">
                <mat-select
                  [(ngModel)]="allocation.state"
                  placeholder="State"
                  [required]="!stateDisabled(allocation)"
                  [ngModelOptions]="{ standalone: true }"
                  (selectionChange)="updateMatchingBusinessUnits(i)"
                >
                  @for (option of allocation.stateOptions; track option) {
                    <mat-option style="color: #696969" [value]="option"
                      ><span>{{ option }}</span></mat-option
                    >
                  }
                </mat-select>
              </mat-form-field>
            </div>
            @if (isRepeatedOperatingUnit(i) && !stateDisabled(allocation)) {
              <div style="display: inline-block; margin-top: 1.125rem; margin-left: 0.683rem">
                @if (isRepeatedOperatingUnit(i) && !stateDisabled(allocation)) {
                  <mat-form-field
                    class="itFields"
                    style="width: 6.563rem; background-color: #f3fafd"
                  >
                    <input
                      type="text"
                      placeholder="State"
                      matInput
                      [(ngModel)]="allocation.state"
                      readonly="true"
                      required
                      [ngModelOptions]="{ standalone: true }"
                    />
                  </mat-form-field>
                }
              </div>
            }
            <div
              [class.removeElement]="
                !isAllocationFunctionVisible(allocations) && !showFunctionField(allocation)
              "
              [class.hiddenElement]="
                isAllocationFunctionVisible(allocations) && !showFunctionField(allocation)
              "
              style="display: inline-block; margin-top: 1.125rem; margin-left: 0.683rem"
            >
              <mat-form-field class="itFields" style="width: 6.563rem">
                <mat-select
                  [(ngModel)]="allocation.function"
                  placeholder="Function"
                  [required]="true"
                  [ngModelOptions]="{ standalone: true }"
                >
                  @for (option of getAllocationFunctions(allocation); track option) {
                    <mat-option style="color: #696969" [value]="option"
                      ><span>{{ option }}</span></mat-option
                    >
                  }
                </mat-select>
              </mat-form-field>
            </div>
            <div style="display: inline-block; margin-top: 1.125rem; margin-left: 0.683rem">
              <mat-form-field class="itFields" style="width: 7rem">
                <input
                  type="number"
                  [min]="0"
                  onkeypress="return event.charCode != 45;"
                  [(ngModel)]="allocation.percentage"
                  placeholder="Percentage"
                  matInput
                  required
                  [ngModelOptions]="{ standalone: true }"
                />
              </mat-form-field>
            </div>
            <div style="display: inline-block; margin-top: 1.125rem; margin-right: 0.5rem">
              <img
                [class.hiddenElement]="isRevisionIndicator"
                style="cursor: pointer; width: 1rem; height: 1rem; padding-left: 1rem"
                src="assets/trash-bin-base.svg"
                (click)="deleteAllocation(i)"
              />
            </div>
          </div>
          <div style="height: 0.1rem; background-color: #f5f5f5; width: 78rem"></div>
        </div>
      }
      <div
        style="background-color: #f3fafd"
        [ngStyle]="{
          width: isAllocationFunctionVisible(allocations) ? '90rem' : '78rem',
        }"
      >
        <div
          style="
            padding-left: 1rem;
            padding-top: 1.188rem;
            padding-bottom: 1.313rem;
            cursor: pointer;
            width: 15rem;
          "
          (click)="addNewAllocation()"
        >
          <span
            [class.hiddenElement]="isRevisionIndicator"
            style="font-weight: bold; font-size: 1.4rem"
            >&#43;</span
          >
          <span
            [class.hiddenElement]="isRevisionIndicator"
            style="padding-left: 0.2rem; text-decoration: underline; text-underline-offset: 0.2rem"
            >Add New Unit Line</span
          >
        </div>
        <div style="position: relative; float: right; margin-top: -4rem; margin-right: 3.6rem">
          <div>
            <span style="color: #696969">Total Allocation:</span>
          </div>
          <div>
            <span style="color: #696969; font-weight: bold">{{ allocationTotal() }}%</span>
          </div>
        </div>
        <div
          [class.removeElement]="!emptyAllocationLine()"
          style="
            text-align: right;
            padding-right: 0.688rem;
            padding-bottom: 0.625rem;
            color: darkred;
          "
        >
          <span
            >Allocation % for an Operating Unit cannot be zero. Please add a percentage value or
            delete the line.</span
          >
        </div>
        <div
          [class.removeElement]="!multipleNuclearHardwareSoftware()"
          style="
            text-align: right;
            padding-right: 0.688rem;
            padding-bottom: 0.625rem;
            color: darkred;
          "
        >
          <span
            >Cannot enter Hardware and Software on a single form when allocating across Nuclear
            Stations. Please change the form to either be Hardware or Software, and then enter an
            additional form for the other one.
          </span>
        </div>
        <div
          [class.removeElement]="allocationTotal() == 100"
          style="
            text-align: right;
            padding-right: 0.688rem;
            padding-bottom: 0.625rem;
            color: darkred;
          "
        >
          <span>Total Allocation must equal 100% in order to proceed</span>
        </div>
        <div
          [class.removeElement]="
            emptyAllocationLine() ||
            duplicateAllocation() ||
            multipleNuclearHardwareSoftware() ||
            sameNuclearSite() ||
            !(allocationTotal() == 100)
          "
          style="
            text-align: right;
            padding-right: 0.688rem;
            padding-bottom: 0.625rem;
            color: darkred;
          "
        >
          <span></span>
        </div>
      </div>
      <div style="margin-top: 1.5rem; margin-bottom: 0.5rem">
        <span class="projectScopeHeader">Estimate Details</span>
      </div>
      <div style="background-color: #f3fafd; padding-top: 1.5rem; width: 78rem">
        <div style="width: 78rem; margin-bottom: 1.5rem; text-align: center">
          <span class="projectScopeHeader">Material Details</span>
        </div>
        <div style="height: 0.1rem; background-color: #f5f5f5"></div>
      </div>
      @for (building of buildings; track building; let i = $index) {
        <div>
          <div
            style="width: 78rem"
            [class.backgroundColorBlue]="!isOdd(i)"
            [class.backgroundColorGray]="isOdd(i)"
          >
            <div style="padding-left: 1.5rem; padding-top: 1.156rem">
              <span class="projectScopeSubHeader">Building</span>
            </div>
            @if (!isExtraBuilding(building.buildingName)) {
              <div style="display: inline-block; margin-top: 0.625rem; margin-left: 1.5rem">
                <mat-form-field class="itFields" style="width: 36.75rem">
                  <input
                    type="text"
                    placeholder="Building Name"
                    matAutocompletePosition="below"
                    matInput
                    [matAutocomplete]="auto2"
                    [formControl]="buildingControl[i]"
                    [(ngModel)]="building.buildingName"
                    required
                    [name]="'building.buildingNameField' + i"
                  />
                </mat-form-field>
                <mat-autocomplete
                  #auto2="matAutocomplete"
                  [displayWith]="displayFnBuildingInfo"
                  (optionSelected)="setBuildingAsTouched(i)"
                >
                  @for (option of filteredBuildingOptions[i] | async; track option) {
                    <mat-option style="color: #696969" [value]="option"
                      ><span>{{ option.BuildingName }}</span></mat-option
                    >
                  }
                </mat-autocomplete>
                @if (building && building.buildingName && building.buildingName.BuildingName) {
                  <div
                    style="
                      display: inline-block;
                      padding-top: 0.8rem;
                      z-index: 0;
                      position: absolute;
                    "
                  >
                    <img
                      (click)="deleteBuildingName(i)"
                      style="margin-left: -1.5rem; cursor: pointer"
                      src="assets/close-window.svg"
                    />
                  </div>
                }
              </div>
            }
            @if (isExtraBuilding(building.buildingName)) {
              <div style="display: inline-block; margin-top: 0.625rem; margin-left: 1.5rem">
                <mat-form-field class="itFields" style="width: 36.75rem; background-color: #f3fafd">
                  <input
                    type="text"
                    placeholder="Building Name"
                    matInput
                    [(ngModel)]="building.buildingName.BuildingName"
                    readonly="true"
                    required
                    [name]="'building.buildingName.BuildingNameField' + i"
                  />
                </mat-form-field>
              </div>
            }
            @if (!isExtraBuilding(building.buildingName)) {
              <div style="display: inline-block; margin-top: 1.125rem; margin-right: 0.5rem">
                <img
                  style="cursor: pointer; width: 1rem; height: 1rem; padding-left: 1rem"
                  src="assets/trash-bin-base.svg"
                  (click)="deleteBuilding(i)"
                />
              </div>
            }
            @if (!isExtraBuilding(building.buildingName)) {
              <div style="display: inline-block">
                <span class="projectScopeText"
                  >Note: Deleting the building will delete all Material entries associated with
                  it</span
                >
              </div>
            }
            @if (building.materialEstimates && building.materialEstimates.length > 0) {
              <div>
                @if (building.buildingName) {
                  <div style="padding-left: 1.5rem; padding-top: 1.156rem">
                    <span class="projectScopeSubHeader"
                      >Materials for {{ building.buildingName.BuildingName }}</span
                    >
                  </div>
                }
                @if (!building.buildingName) {
                  <div style="padding-left: 1.5rem; padding-top: 1.156rem">
                    <span class="projectScopeSubHeader">Materials for </span>
                  </div>
                }
                @for (estimate of building.materialEstimates; track estimate; let j = $index) {
                  <div
                    [class.adjustForWarning]="
                      j !== 0 && tangiblePropertyCheck(building.materialEstimates[j - 1])
                    "
                  >
                    <div
                      [class.errorBorder]="tangiblePropertyCheck(estimate)"
                      style="display: inline-block; margin-top: 1.125rem; margin-left: 1.5rem"
                    >
                      <mat-form-field class="itFields" style="width: 5.625rem">
                        <mat-select
                          [(ngModel)]="estimate.cost"
                          placeholder="Cost"
                          (selectionChange)="costChanged($event.value, i, j)"
                          [required]="isMaterialRequired() || !materialsFilledOut()"
                          [ngModelOptions]="{ standalone: true }"
                        >
                          @for (option of costOptions; track option) {
                            <mat-option style="color: #696969" [value]="option"
                              ><span>{{ option }}</span></mat-option
                            >
                          }
                        </mat-select>
                      </mat-form-field>
                    </div>
                    <div style="display: inline-block; margin-top: 1.125rem; margin-left: 0.438rem">
                      <mat-form-field class="itFields" style="width: 18rem">
                        <input
                          [(ngModel)]="estimate.unitOfPropertyDetails"
                          placeholder="Details"
                          matInput
                          [required]="isMaterialRequired() || !materialsFilledOut()"
                          [name]="'estimate.unitOfPropertyDetailsField' + i + j"
                        />
                      </mat-form-field>
                    </div>
                    <div
                      style="display: inline-block; margin-top: 1.125rem; margin-left: 0.438rem"
                      [ngStyle]="{
                        width: estimate.cost !== 'O&M' ? 'auto' : '25.35rem',
                      }"
                    >
                      @if (estimate.cost !== 'O&M') {
                        <mat-form-field class="itFields" style="width: 24.313rem">
                          <mat-select
                            [(ngModel)]="estimate.unitOfPropertyDescription"
                            placeholder="Unit of Property Description"
                            [required]="isMaterialRequired() || !materialsFilledOut()"
                            [ngModelOptions]="{ standalone: true }"
                          >
                            @for (option of uopOptions; track option) {
                              <mat-option style="color: #696969" [value]="option"
                                ><span>{{ option }}</span></mat-option
                              >
                            }
                          </mat-select>
                        </mat-form-field>
                      }
                    </div>
                    <div style="display: inline-block; margin-top: 1.125rem; margin-left: 0.438rem">
                      <mat-form-field class="itFields" style="width: 5.625rem">
                        <input
                          [allowDecimals]="false"
                          appCurrencyMask
                          appNumbersOnly
                          onkeypress="return event.charCode != 45;"
                          [(ngModel)]="estimate.quantity"
                          placeholder="Quantity"
                          matInput
                          (keyup)="recalculateTotalCost(i, j)"
                          [required]="isMaterialRequired() || !materialsFilledOut()"
                          [name]="'estimate.quantityField' + i + j"
                        />
                      </mat-form-field>
                    </div>
                    <div
                      [class.errorBorder]="
                        tangiblePropertyCheck(estimate) ||
                        (!tangibleTotalCostCheck(estimate) && tangibleDateCheck(estimate))
                      "
                      style="display: inline-block; margin-top: 1.125rem; margin-left: 0.438rem"
                    >
                      <mat-form-field class="itFields" style="width: 6rem" [floatLabel]="'always'">
                        <input
                          appCurrencyMask
                          appNumbersOnly
                          [allowDecimals]="false"
                          onkeypress="return event.charCode != 45;"
                          [(ngModel)]="estimate.unitCosts"
                          placeholder="Unit Costs"
                          matInput
                          (keyup)="recalculateTotalCost(i, j)"
                          [required]="isMaterialRequired() || !materialsFilledOut()"
                          [name]="'estimate.unitCostsField' + i + j"
                        />
                        <span matPrefix>$</span>
                      </mat-form-field>
                    </div>
                    <div
                      [class.errorBorder]="tangibleTotalCostCheck(estimate)"
                      style="display: inline-block; margin-top: 1.125rem; margin-left: 0.438rem"
                    >
                      <mat-form-field
                        class="itFields"
                        style="width: 6rem; background-color: #f3fafd"
                        [floatLabel]="'always'"
                      >
                        <input
                          readonly="true"
                          [value]="+estimate.totalCosts | CurrencyUSD: 'USD' : true : false"
                          placeholder="Total Costs"
                          matInput
                          [required]="isMaterialRequired() || !materialsFilledOut()"
                          [name]="'estimate.totalCostsField' + i + j"
                        />
                      </mat-form-field>
                    </div>
                    <div style="display: inline-block; margin-top: 1.125rem; margin-right: 0.5rem">
                      <img
                        style="cursor: pointer; width: 1rem; height: 1rem; padding-left: 1rem"
                        src="assets/trash-bin-base.svg"
                        (click)="deleteEstimate(i, j)"
                      />
                    </div>
                    @if (tangiblePropertyCheck(estimate)) {
                      <div
                        style="justify-self: right; padding-top: 0.625rem; padding-right: 1.5rem"
                      >
                        <span style="color: #9e1b32; font-size: 0.875rem"
                          >Tangible (non-software) units of property must have a unit cost of at
                          least $500 to qualify as capital</span
                        >
                      </div>
                    }
                    @if (tangibleTotalCostCheck(estimate)) {
                      <div
                        style="justify-self: right; padding-top: 0.625rem; padding-right: 1.5rem"
                      >
                        <span style="color: #9e1b32; font-size: 0.875rem"
                          >If tangible (non-software) units of property have a unit cost between
                          $500 and $999, then the total cost must be at least $50,000 to qualify as
                          capital</span
                        >
                      </div>
                    }
                    @if (!tangibleTotalCostCheck(estimate) && tangibleDateCheck(estimate)) {
                      <div
                        style="justify-self: right; padding-top: 0.625rem; padding-right: 1.5rem"
                      >
                        <span style="color: #9e1b32; font-size: 0.875rem"
                          >If tangible (non-software) units of property have a unit cost between
                          $500 and $999, the work must be scheduled to be done within 12 months to
                          qualify as capital</span
                        >
                      </div>
                    }
                  </div>
                }
              </div>
            }
            <div
              style="width: 78rem"
              [class.backgroundColorBlue]="!isOdd(i)"
              [class.backgroundColorGray]="isOdd(i)"
            >
              <div
                style="
                  padding-left: 2rem;
                  padding-top: 1.188rem;
                  padding-bottom: 1.313rem;
                  cursor: pointer;
                  width: 15rem;
                "
                (click)="addMaterial(i)"
              >
                <span style="font-weight: bold; font-size: 1.4rem">&#43;</span>
                <span
                  style="
                    padding-left: 0.2rem;
                    text-decoration: underline;
                    text-underline-offset: 0.2rem;
                  "
                  >Add New Material</span
                >
              </div>
            </div>
            <div style="height: 0.1rem; background-color: #f5f5f5; width: 78rem"></div>
          </div>
        </div>
      }
      <div style="width: 78rem; background-color: #f3fafd">
        <div
          [class.noClick]="isExtraBuilding(buildings[0].buildingName)"
          style="
            padding-left: 1rem;
            padding-top: 1.188rem;
            padding-bottom: 1.313rem;
            cursor: pointer;
            width: 15rem;
          "
          (click)="addBuilding()"
        >
          <span
            [class.hiddenElement]="isExtraBuilding(buildings[0].buildingName)"
            style="font-weight: bold; font-size: 1.4rem"
            >&#43;</span
          >
          <span
            [class.hiddenElement]="isExtraBuilding(buildings[0].buildingName)"
            style="padding-left: 0.2rem; text-decoration: underline; text-underline-offset: 0.2rem"
            >Add Another Building</span
          >
        </div>
        <div style="position: relative; float: right; margin-top: -4rem; margin-right: 3.6rem">
          <div>
            <span style="color: #696969">Total Estimated:</span>
          </div>
          <div>
            <span style="color: #696969; font-weight: bold"
              >${{ buildingTotal().toLocaleString('en', { useGrouping: true }) }}</span
            >
          </div>
        </div>
      </div>
      <div
        style="
          background-color: #f3fafd;
          padding-top: 1.5rem;
          width: 78rem;
          margin-top: 0.688rem;
          display: inline-block;
        "
      >
        <div style="width: 78rem; margin-bottom: 1.5rem; text-align: center">
          <span class="projectScopeHeader">Employee/Contractor Labor Details</span>
        </div>
        <div style="height: 0.1rem; background-color: #f5f5f5"></div>
      </div>

      <div class="columnNamesContainer">
        <span style="min-width: 13.5rem; padding-left: 2rem" class="columnName"> Work Task </span>
        <span style="min-width: 41.5rem" class="columnName"> Work Description </span>
        <span style="min-width: 10.5rem" class="columnName"> Charge Type </span>
        <span style="min-width: 6rem" class="columnName"> Total Costs </span>
      </div>

      <div style="width: 78rem; height: 6.25rem; background-color: #f3fafd; display: inline-block">
        @for (detail of laborDetails; track detail; let i = $index) {
          <div style="background-color: #f3fafd">
            <div style="display: inline-block; margin-top: 1.125rem; margin-left: 1.5rem">
              <mat-form-field class="itFields" style="width: 12rem">
                <mat-select
                  [(ngModel)]="detail.workTask"
                  placeholder="Work Task"
                  (selectionChange)="workTaskChanged($event.value, i)"
                  [required]="isEmployeeContractorRequired()"
                  [ngModelOptions]="{ standalone: true }"
                  [compareWith]="compareWorkTask"
                >
                  @for (option of workTaskOptions; track option) {
                    <mat-option style="color: #696969" [value]="option"
                      ><span>{{ option.workTask }}</span></mat-option
                    >
                  }
                </mat-select>
              </mat-form-field>
            </div>
            <div style="display: inline-block; margin-top: 1.125rem; margin-left: 0.5rem">
              @if (workDescriptions[i] && workDescriptions[i].length === 0) {
                <mat-form-field
                  class="itFields"
                  style="width: 39.875rem; background-color: #f3fafd"
                >
                  <input
                    type="text"
                    placeholder="Work Description"
                    matInput
                    [(ngModel)]="detail.workDescription"
                    readonly="true"
                    [required]="isEmployeeContractorRequired()"
                    [name]="'laborDetail.workDescriptionField' + i"
                  />
                </mat-form-field>
              }
              <mat-form-field
                [class.removeElement]="workDescriptions[i] && workDescriptions[i].length === 0"
                class="itFields"
                style="width: 39.875rem"
              >
                <mat-select
                  [(ngModel)]="detail.workDescription"
                  placeholder="Work Description"
                  [required]="isEmployeeContractorRequired()"
                  [ngModelOptions]="{ standalone: true }"
                >
                  @for (option of workDescriptions[i]; track option) {
                    <mat-option style="color: #696969" [value]="option"
                      ><span>{{ option }}</span></mat-option
                    >
                  }
                </mat-select>
              </mat-form-field>
            </div>
            <div style="display: inline-block; margin-top: 1.125rem; margin-left: 0.5rem">
              <mat-form-field class="itFields" style="width: 9rem">
                <mat-select
                  [(ngModel)]="detail.chargeType"
                  placeholder="Charge Type"
                  [required]="isEmployeeContractorRequired()"
                  [ngModelOptions]="{ standalone: true }"
                >
                  @for (option of chargeTypeOptions; track option) {
                    <mat-option style="color: #696969" [value]="option"
                      ><span>{{ option }}</span></mat-option
                    >
                  }
                </mat-select>
              </mat-form-field>
            </div>
            <div style="display: inline-block; margin-top: 1.125rem; margin-left: 0.438rem">
              <mat-form-field class="itFields" style="width: 6rem" [floatLabel]="'always'">
                <input
                  appCurrencyMask
                  appNumbersOnly
                  [allowDecimals]="false"
                  onkeypress="return event.charCode != 45;"
                  [(ngModel)]="detail.totalCosts"
                  placeholder="Total Costs"
                  matInput
                  [required]="isEmployeeContractorRequired()"
                  [name]="'laborDetail.totalCostsField' + i"
                />
                <span matPrefix>$</span>
              </mat-form-field>
            </div>
            <div style="display: inline-block; margin-top: 1.125rem; margin-right: 0.5rem">
              <img
                style="cursor: pointer; width: 1rem; height: 1rem; padding-left: 1rem"
                src="assets/trash-bin-base.svg"
                (click)="deleteLaborDetail(i)"
              />
            </div>
          </div>
        }
        <div style="width: 78rem; background-color: #f3fafd">
          <div
            style="
              padding-left: 1rem;
              padding-top: 1.188rem;
              padding-bottom: 1.313rem;
              cursor: pointer;
              width: 15rem;
            "
            (click)="addLaborDetail()"
          >
            <span style="font-weight: bold; font-size: 1.4rem">&#43;</span>
            <span
              style="
                padding-left: 0.2rem;
                text-decoration: underline;
                text-underline-offset: 0.2rem;
              "
              >Add New Labor</span
            >
          </div>
          <div style="position: relative; float: right; margin-top: -4rem; margin-right: 3.6rem">
            <div>
              <span style="color: #696969">Total Estimated:</span>
            </div>
            <div>
              <span style="color: #696969; font-weight: bold"
                >${{ laborTotal().toLocaleString('en', { useGrouping: true }) }}</span
              >
            </div>
          </div>
        </div>
      </div>
      <div
        style="
          background-color: #f3fafd;
          padding-top: 1.5rem;
          width: 78rem;
          margin-top: 2.2rem;
          display: inline-block;
        "
      >
        <div style="width: 78rem; margin-bottom: 1.5rem; text-align: center">
          <span class="projectScopeHeader">Contingency and Other Details (Optional)</span>
        </div>
        <div style="height: 0.1rem; background-color: #f5f5f5"></div>
      </div>

      <div class="columnNamesContainer">
        <span style="min-width: 16.5rem; padding-left: 2rem" class="columnName"> Cost </span>
        <span style="min-width: 48.5rem" class="columnName"> Description </span>
        <span style="min-width: 6rem" class="columnName"> Total Costs </span>
      </div>

      <div style="width: 78rem; height: 6.25rem; background-color: #f3fafd; display: inline-block">
        @for (detail of contingencyDetails; track detail; let i = $index) {
          <div style="background-color: #f3fafd">
            <div style="display: inline-block; margin-top: 1.125rem; margin-left: 1.5rem">
              <mat-form-field class="itFields" style="width: 15rem">
                <mat-select
                  [(ngModel)]="detail.cost"
                  placeholder="Cost"
                  [ngModelOptions]="{ standalone: true }"
                  [required]="isContingencyRowMissing(i, 'cost')"
                >
                  @for (option of contingencyCostOptions; track option) {
                    <mat-option style="color: #696969" [value]="option"
                      ><span>{{ option }}</span></mat-option
                    >
                  }
                </mat-select>
              </mat-form-field>
            </div>
            <div style="display: inline-block; margin-top: 1.125rem; margin-left: 0.5rem">
              <mat-form-field class="itFields" style="width: 47.15rem">
                <input
                  [(ngModel)]="detail.description"
                  placeholder="Description"
                  matInput
                  [name]="'contingencyDetail.descriptionField' + i"
                  [required]="isContingencyRowMissing(i, 'description')"
                />
              </mat-form-field>
            </div>
            <div style="display: inline-block; margin-top: 1.125rem; margin-left: 0.438rem">
              <mat-form-field class="itFields" style="width: 6rem" [floatLabel]="'always'">
                <input
                  appCurrencyMask
                  appNumbersOnly
                  [allowDecimals]="false"
                  onkeypress="return event.charCode != 45;"
                  [(ngModel)]="detail.totalCosts"
                  placeholder="Total Costs"
                  matInput
                  [name]="'contingencyDetail.totalCostsField' + i"
                  [required]="isContingencyRowMissing(i, 'totalCosts')"
                />
                <span matPrefix>$</span>
              </mat-form-field>
            </div>
            <div style="display: inline-block; margin-top: 1.125rem; margin-right: 0.5rem">
              <img
                style="cursor: pointer; width: 1rem; height: 1rem; padding-left: 1rem"
                src="assets/trash-bin-base.svg"
                (click)="deleteContingencyDetail(i)"
              />
            </div>
          </div>
        }
        <div style="width: 78rem; background-color: #f3fafd">
          <div
            style="
              padding-left: 1rem;
              padding-top: 1.188rem;
              padding-bottom: 1.313rem;
              cursor: pointer;
              width: 15rem;
            "
            (click)="addContingencyDetail()"
          >
            <span style="font-weight: bold; font-size: 1.4rem">&#43;</span>
            <span
              style="
                padding-left: 0.2rem;
                text-decoration: underline;
                text-underline-offset: 0.2rem;
              "
              >Add New Contingency/Other</span
            >
          </div>
          <div style="position: relative; float: right; margin-top: -4rem; margin-right: 3.6rem">
            <div>
              <span style="color: #696969">Total Estimated:</span>
            </div>
            <div>
              <span style="color: #696969; font-weight: bold"
                >${{ contingencyTotal().toLocaleString('en', { useGrouping: true }) }}</span
              >
            </div>
          </div>
        </div>
      </div>
      <div
        style="
          background-color: #f3fafd;
          padding-top: 1.5rem;
          width: 78rem;
          margin-top: 2.2rem;
          display: inline-block;
          padding-bottom: 1rem;
        "
      >
        <div style="width: 78rem; margin-bottom: 1.5rem; text-align: center">
          <div class="projectScopeHeader pb-1">Cost Summary</div>
          <div style="height: 0.1rem; background-color: #f5f5f5"></div>
        </div>

        <div class="cost-container mb-1 pb-1 grey-border-bottom">
          <div class="cost-column">Total Capital $ by Charge Type</div>
          <div class="cost-column"></div>
          <div class="cost-column">Total O&M $ by Charge Type</div>
          <div class="cost-column"></div>
          <div class="cost-column"></div>
          <div class="cost-column"></div>
        </div>

        <div class="cost-container">
          <div class="cost-column">Internal Labor</div>
          <div class="cost-column">
            ${{ internalCapital().toLocaleString('en', { useGrouping: true }) }}
          </div>
          <div class="cost-column">Internal Labor</div>
          <div class="cost-column">
            ${{ internalOM().toLocaleString('en', { useGrouping: true }) }}
          </div>
          <div class="cost-column">Capital Cost</div>
          <div class="cost-column">
            ${{ subtotalCapital().toLocaleString('en', { useGrouping: true }) }}
          </div>
        </div>

        <div class="cost-container">
          <div class="cost-column">External Labor</div>
          <div class="cost-column">
            ${{ externalCapital().toLocaleString('en', { useGrouping: true }) }}
          </div>
          <div class="cost-column">External Labor</div>
          <div class="cost-column">
            ${{ externalOM().toLocaleString('en', { useGrouping: true }) }}
          </div>
          <div class="cost-column">Estimated AFUDC of Project</div>
          <div class="cost-column">
            ${{ estimatedAFUDC().toLocaleString('en', { useGrouping: true }) }}
          </div>
        </div>

        <div class="cost-container">
          <div class="cost-column">Material</div>
          <div class="cost-column">
            ${{ materialCapital().toLocaleString('en', { useGrouping: true }) }}
          </div>
          <div class="cost-column">Material</div>
          <div class="cost-column">
            ${{ materialOM().toLocaleString('en', { useGrouping: true }) }}
          </div>
          <div class="cost-column">Total Capital Cost</div>
          <div class="cost-column">
            ${{ totalCapitalCost().toLocaleString('en', { useGrouping: true }) }}
          </div>
        </div>

        <div class="cost-container">
          <div class="cost-column">Contingency</div>
          <div class="cost-column">
            ${{ contingencyCapital().toLocaleString('en', { useGrouping: true }) }}
          </div>
          <div class="cost-column">Contingency</div>
          <div class="cost-column">
            ${{ contingencyOM().toLocaleString('en', { useGrouping: true }) }}
          </div>
          <div class="cost-column"></div>
          <div class="cost-column"></div>
        </div>

        <div class="cost-container">
          <div class="cost-column">Other</div>
          <div class="cost-column">
            ${{ otherCapital().toLocaleString('en', { useGrouping: true }) }}
          </div>
          <div class="cost-column">Other</div>
          <div class="cost-column">
            ${{ otherOM().toLocaleString('en', { useGrouping: true }) }}
          </div>
          <div class="cost-column"></div>
          <div class="cost-column"></div>
        </div>

        <div class="cost-container">
          <div class="cost-column">Subtotal</div>
          <div class="cost-column">
            ${{ subtotalCapital().toLocaleString('en', { useGrouping: true }) }}
          </div>
          <div class="cost-column">Subtotal</div>
          <div class="cost-column">
            ${{ subtotalOM().toLocaleString('en', { useGrouping: true }) }}
          </div>
          <div class="cost-column">Total O&M Cost</div>
          <div class="cost-column">
            ${{ subtotalOM().toLocaleString('en', { useGrouping: true }) }}
          </div>
        </div>

        <div class="cost-container">
          <div class="cost-column">Subtotal This Request</div>
          <div class="cost-column">
            ${{
              subtotalCapitalThisRequest().toLocaleString('en', {
                useGrouping: true,
              })
            }}
          </div>
          <div class="cost-column">Subtotal This Request</div>
          <div class="cost-column">
            ${{
              subtotalOMThisRequest().toLocaleString('en', {
                useGrouping: true,
              })
            }}
          </div>
          <div class="cost-column">Total Cost (Including AFUDC)</div>
          <div class="cost-column">
            ${{ totalProjectCost().toLocaleString('en', { useGrouping: true }) }}
          </div>
        </div>
      </div>
      <div style="margin-top: 1.5rem; margin-bottom: 0.5rem">
        <span class="projectScopeHeader">Additional Comments to ITPAC (Optional)</span>
      </div>
      <div style="margin-top: 0.688rem">
        <textarea
          [(ngModel)]="additionalComments"
          class="scopeDescriptionTextBox"
          maxlength="255"
          name="additionalCommentsField"
        ></textarea>
      </div>
      <div>
        <span style="color: #696969; font-style: italic; margin-right: 36.938rem; float: right"
          >{{ additionalCommentLength() }} / 255 characters</span
        >
      </div>
      <div style="margin-top: 1.5rem; margin-bottom: 0.5rem">
        <span class="projectScopeHeader">Attachments</span>
      </div>
      <div style="margin-top: 0.5rem; margin-bottom: 0.5rem">
        <span class="projectScopeNonHeader"
          >Note: Files are for review purposes only. Files uploaded in MMAPS will
          <span style="font-style: italic; font-size: 0.9rem">not</span> be added to
          PowerPlan.</span
        >
      </div>
      <input
        type="file"
        style="display: none"
        (change)="onFileSelected($event)"
        #fileUpload
        multiple
      />
      <div
        (drop)="onDrop($event)"
        (dragover)="onDragOver($event)"
        style="
          width: 49.125rem;
          height: 4.063rem;
          border: 0.063rem solid #ccc;
          border-radius: 0.875rem;
        "
      >
        <div style="text-align: center; margin-top: 1.125rem">
          <img style="width: 1rem; height: 1rem; padding-left: 1rem" src="assets/attach-file.svg" />
          <span style="color: rgb(105, 105, 105)">Drop a file here or </span>
          <span style="cursor: pointer" (click)="fileUpload.click()">browse to upload</span>
        </div>
      </div>
      @if (files.length > 0) {
        <div
          style="
            background-color: #f3fafd;
            padding-top: 1.5rem;
            width: 48.375rem;
            margin-top: 1.5rem;
            display: inline-block;
            padding-bottom: 1rem;
          "
        >
          <div style="margin-top: 1.5rem; margin-left: 1.5rem">
            <div style="display: inline-block">
              <span class="projectScopeSubHeader" style="font-size: 0.875rem">File Name</span>
            </div>
            <div style="display: inline-block; margin-left: 15rem">
              <span class="projectScopeSubHeader" style="font-size: 0.875rem">Added By</span>
            </div>
            <div style="display: inline-block; margin-left: 10rem">
              <span class="projectScopeSubHeader" style="font-size: 0.875rem">Date</span>
            </div>
            <div
              style="
                display: inline-block;
                height: 0.1rem;
                background-color: #f5f5f5;
                margin-bottom: 0.5rem;
                width: 46rem;
              "
            ></div>
            @for (file of files; track file; let i = $index) {
              <div>
                <div style="display: inline-block; width: 19.05rem">
                  <span class="projectScopeNonHeader" style="font-size: 0.875rem">{{
                    file.fileName
                  }}</span>
                </div>
                <div style="display: inline-block; width: 13.95rem">
                  <span class="projectScopeNonHeader" style="font-size: 0.875rem">{{
                    file.addedByName
                  }}</span>
                </div>
                <div style="display: inline-block">
                  <span class="projectScopeNonHeader" style="font-size: 0.875rem">{{
                    file.date
                  }}</span>
                </div>
                <div style="display: inline-block; margin-top: 1.125rem; margin-right: 0.5rem">
                  <img
                    style="cursor: pointer; width: 1rem; height: 1rem; padding-left: 3.5rem"
                    src="assets/file-download.svg"
                    (click)="downloadFile(i)"
                  />
                </div>
                <div style="display: inline-block; margin-top: 1.125rem; margin-right: 0.5rem">
                  <img
                    style="cursor: pointer; width: 1rem; height: 1rem; padding-left: 1rem"
                    src="assets/trash-bin-base.svg"
                    (click)="deleteFile(i)"
                  />
                </div>
              </div>
            }
          </div>
        </div>
      }
      <div style="margin-top: 1.5rem; margin-bottom: 0.5rem">
        <span class="projectScopeHeader">Approvers</span>
      </div>
      <div
        style="
          background-color: #f3fafd;
          padding-top: 1.5rem;
          width: 78rem;
          margin-top: 1.5rem;
          display: inline-block;
        "
      >
        <div style="margin-top: 1.5rem; margin-left: 1.5rem">
          <div style="display: inline-block">
            <span class="projectScopeSubHeader" style="font-size: 0.875rem">Name, Title</span>
          </div>
          <div style="display: inline-block; margin-left: 60.438rem">
            <span class="projectScopeSubHeader" style="font-size: 0.875rem"
              >DOA Authority Amount</span
            >
          </div>
        </div>
        <div
          style="
            display: inline-block;
            height: 0.1rem;
            background-color: #f5f5f5;
            margin-left: 1.5rem;
            margin-bottom: 0.5rem;
            width: 75.625rem;
          "
        ></div>
        <div style="margin-left: 1.5rem; padding-bottom: 1.5rem">
          <div style="display: inline-block; width: 65.125rem">
            <span class="projectScopeSubHeader" style="font-size: 0.875rem"
              >{{ itSponsor.givenName }} {{ itSponsor.surname }}, Sponsor</span
            >
          </div>
          <div style="display: inline-block; width: 4.125rem">
            <span class="projectScopeSubHeader" style="font-size: 0.875rem"
              >${{ doaAmounts[0].toLocaleString('en', { useGrouping: true }) }}</span
            >
          </div>
        </div>
      </div>
      @for (approver of approverList; track approver; let i = $index) {
        <div style="width: 78rem; height: 6.25rem; background-color: #f3fafd">
          <mat-form-field
            class="itFields"
            style="margin-top: 1.125rem; margin-left: 1.5rem; width: 50.763rem; height: 4rem"
          >
            <input
              [name]="autocompleteName(i)"
              type="text"
              matAutocompletePosition="below"
              matInput
              [matAutocomplete]="auto1"
              [formControl]="additionalApproverControl[i]"
              [(ngModel)]="additionalApprovers[i]"
              (keydown.enter)="searchUsersAdditionalApprover($event.target.value, i)"
              required
              [name]="'additionalApprover' + i"
            />
          </mat-form-field>
          <mat-autocomplete
            #auto1="matAutocomplete"
            [displayWith]="displayFnAdditionalApprover"
            (optionSelected)="additionalApproverSelected($event.option.value, i)"
          >
            @for (option of additionalApproverOptions[i]; track option) {
              <mat-option style="color: #696969" [value]="option">
                @if (option.givenName && option.surname && option.jobTitle) {
                  <span
                    >{{ option.givenName }} {{ option.surname }} ({{ option.mail }}),
                    {{ option.jobTitle }}</span
                  >
                }
                @if (option.givenName && option.surname && !option.jobTitle) {
                  <span>{{ option.givenName }} {{ option.surname }} ({{ option.mail }})</span>
                }
                @if (!(option.givenName && option.surname) && option.jobTitle) {
                  <span>{{ option.displayName }} ({{ option.mail }}), {{ option.jobTitle }}</span>
                }
                @if (!(option.givenName && option.surname) && !option.jobTitle) {
                  <span>{{ option.displayName }} ({{ option.mail }})</span>
                }
              </mat-option>
            }
          </mat-autocomplete>
          @if (additionalApprovers[i] && additionalApprovers[i].displayName) {
            <div style="display: inline-block; padding-top: 1.8rem; z-index: 0; position: absolute">
              <img
                (click)="deleteAdditionalApproverValue(i)"
                style="margin-left: -1.5rem; cursor: pointer"
                src="assets/close-window.svg"
              />
            </div>
          }
          <div
            style="display: inline-block; margin-left: 0.938rem"
            (click)="searchUsersAdditionalApprover(additionalApprovers[i], i)"
          >
            <button class="confirmButton" type="button" style="width: 5rem">
              <span class="confirmText">SEARCH</span>
            </button>
          </div>
          <div style="display: inline-block; margin-left: 5.83rem; width: 4.125rem">
            <span class="projectScopeSubHeader" style="font-size: 0.875rem"
              >${{ doaAmounts[i + 1].toLocaleString('en', { useGrouping: true }) }}</span
            >
          </div>
          <div style="display: inline-block; margin-top: 1.125rem; margin-right: 0.5rem">
            <img
              style="cursor: pointer; width: 1rem; height: 1rem; padding-left: 3.5rem"
              src="assets/trash-bin-base.svg"
              (click)="deleteApprover(i)"
            />
          </div>
        </div>
      }
      <div
        [class.removeElement]="doaAmountMet()"
        style="padding-left: 1.5rem; background-color: #f3fafd; width: 76.5rem"
      >
        <div style="width: 31rem">
          <span style="color: #9e1b32; font-size: 0.875rem"
            >Warning: DOA amount is not high enough. Please add another approver or include an
            explanation of the alternate DOA amount in the comments to ITPAC.</span
          >
        </div>
      </div>
      <div
        style="
          padding-left: 1rem;
          padding-top: 1.188rem;
          padding-bottom: 1.313rem;
          cursor: pointer;
          width: 15rem;
          background-color: #f3fafd;
          width: 77rem;
        "
        (click)="addNewAdditionalApprover()"
      >
        <span style="font-weight: bold; font-size: 1.4rem">&#43;</span>
        <span
          style="padding-left: 0.2rem; text-decoration: underline; text-underline-offset: 0.2rem"
          >Add Another Approver</span
        >
      </div>
    </div>
    <div style="margin-bottom: 4.375rem; margin-top: 3.75rem">
      <div class="startOverButton" (click)="previousPage()">
        <span style="font-size: 0.875rem; color: #00789e">PREVIOUS</span>
      </div>
      <div style="display: inline-block">
        <div class="exitButton" (click)="exitPage()">
          <span class="exitText">EXIT</span>
        </div>
      </div>
      <div style="display: inline-block; float: right">
        <div style="display: inline-block">
          <button
            (click)="confirmAndContinue(projectEstimateForm)"
            class="confirmButton"
            type="submit"
            style="width: 8.125rem"
          >
            <span class="confirmText">REVIEW</span>
          </button>
        </div>
      </div>
      <div style="display: inline-block; float: right; margin-right: 1.4rem">
        <div class="exitButton" (click)="saveDraft()">
          <span class="exitText">SAVE DRAFT</span>
        </div>
      </div>
    </div>
  </form>
</div>
